import type { LineItemForm } from '../../../pages/Campaigns/Form/types';
import { buildCampaignBuilderContextProps } from '../builders/buildCampaignBuilderContextProps';
import { buildDeliveryAdsSummary } from '../builders/deliveryAdsSummary';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_PROPERTY_KEYS,
  CAMPAIGN_BUILDER_STEP_NAMES,
  COMPONENT_OUTCOMES,
  DCM_PAGES,
} from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

type DeliveryAdsEventContext = {
  campaignId?: string;
  lineItemId?: string;
  adAccountId?: string;
  revisionNumber?: string;
  isValidatedEdit?: boolean;
  politicalClassification?: string;
  industryVertical?: string;
  userRole?: string;
};

export type TrackDeliveryAdsAppliedParams = DeliveryAdsEventContext & {
  formValues: LineItemForm;
};

export const trackDeliveryAdsApplied = ({
  formValues,
  politicalClassification,
  industryVertical,
  userRole,
  ...context
}: TrackDeliveryAdsAppliedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.DELIVERY_ADS_APPLIED, {
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.CAMPAIGN_BUILDER,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
    [ANALYTICS_PROPERTY_KEYS.STEP_NAME]: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
    ...buildCampaignBuilderContextProps({
      politicalClassification,
      industryVertical,
      userRole,
      formValues,
    }),
    ...buildDeliveryAdsSummary(formValues, context),
  });
};
